import { createStore, applyMiddleware, Store } from 'redux';
import { createWrapper } from 'next-redux-wrapper';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import { rootReducer } from '@zoopla/redux-reducer-root';
import { RootState } from '@zoopla/redux-types';

const middleware = [thunk];

// used in tests
export const configureStore = (initialState?: RootState) => {
    return createStore(rootReducer, initialState);
};

const makeStore = () => {
    const store = createStore(
        rootReducer,
        composeWithDevTools(applyMiddleware(...middleware))
    );

    return store;
};

export const wrapper = createWrapper<Store<RootState>>(makeStore, {
    debug: false
});
